<template lang="pug">
#monitoramento
    .paddingCondicional
        span(v-if='usuario.historicoMonitoramentoAccess')
            el-switch.toggle(
                v-if='tipoAgricola',
                v-model='abaAtual',
                active-text='Histórico',
                inactive-text='Monitoramento',
                active-color='#a6ce39',
                inactive-color='#a6ce39'
            )

    span.aviso(v-if='!monitoramentoAtivo')
        i.mdi.mdi-alert-circle.warning
        | {{ `O monitoramento deste território foi cancelado em ${dataUltimaAtualizacao.toLocaleDateString('pt-br')}` }}

    .row(v-show='!abaAtual && tipoAgricola')
        grupos-alerta.col-12.alerta-horizontal(
            :class='{ isblocoagricola: isBlocoAgricola }',
            :gruposAlerta='gruposAlerta',
            :altura='90',
            :isHorizontal='true'
        )

    MonitoramentoAgricola(
        v-if='!abaAtual && tipoAgricola',
        :dadosAreaMonitorada='dadosAreaMonitorada'
    )
    Historico(
        v-else-if='abaAtual && podeVisualizarHistorico',
        :dadosAreaMonitorada='dadosAreaMonitorada',
        :altura='90',
        :isHorizontal='true'
    )
    MonitoramentoSocioambiental(
        v-else,
        :idTerritorio='dadosAreaMonitorada.territorio.id',
        :gruposAlerta='gruposAlerta',
        :altura='90',
        :isHorizontal='true'
    )
</template>

<script>
import GruposAlerta from '@/components/GruposAlerta';
import UtilsService from '@/services/UtilsService';
import AuthService from '@/services/AuthService';
import MonitoramentoService from '@/services/MonitoramentoService';
import MonitoramentoAgricola from '@/components/areamonitorada/MonitoramentoAgricola.vue';
import MonitoramentoSocioambiental from '@/components/areamonitorada/MonitoramentoSocioambiental.vue';

import Historico from '@/components/areamonitorada/Historico.vue';

export default {
    name: 'Monitoramento',

    components: {
        GruposAlerta,
        MonitoramentoAgricola,
        MonitoramentoSocioambiental,
        Historico
    },

    props: {
        dadosAreaMonitorada: {
            type: Object,
            required: true
        }
    },

    computed: {
        tipoAgricola() {
            return (
                this.dadosAreaMonitorada.tipoMonitoramento.codigo === 'AGRICOLA'
            );
        },

        usuario() {
            return this.$store.state.usuarioLogado;
        },

        podeVisualizarHistorico() {
            return this.$store.state.usuarioLogado.historicoMonitoramentoAccess;
        }
    },

    data() {
        return {
            gruposAlerta: [],
            abaAtual: false,
            isBlocoAgricola: false,
            monitoramentoAtivo: true,
            dataUltimaAtualizacao: null,
            usuarioLogado: null
        };
    },

    created() {
        this.fetchUsuarioLogado();
        this.findAlertas();
        this.verificarMonitoramentoAtivo();
    },
    methods: {
        findAlertas() {
            const filtro = {
                idAreaMonitorada: this.$route.params.idAreaMonitorada
            };

            UtilsService.findAlertas(filtro)
                .then(result => {
                    // exibindo apenas o card "Alertas Socioambientais"
                    this.isBlocoAgricola = false;
                    if (
                        this.dadosAreaMonitorada.tipoMonitoramento.codigo ===
                        'SOCIOAMBIENTAL'
                    ) {
                        this.gruposAlerta = result.data.filter(
                            item => item.id === 5
                        );
                    } else if (
                        this.dadosAreaMonitorada.tipoMonitoramento.codigo ===
                        'AGRICOLA'
                    ) {
                        this.gruposAlerta = result.data.filter(
                            item => item.id !== 4 && item.id !== 5
                        );
                        this.isBlocoAgricola = true;
                    } else {
                        this.gruposAlerta = result.data.filter(
                            item => item.id !== 4
                        );
                    }
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Ocorreu um erro ao buscar os alertas'
                    });
                });
        },

        verificarMonitoramentoAtivo() {
            MonitoramentoService.verificarMonitoramentoAtivo(
                this.$route.params.idAreaMonitorada
            )
                .then(({ data }) => {
                    this.monitoramentoAtivo = data;

                    if (!this.monitoramentoAtivo) {
                        this.buscarDataUltimaAtualizacao();
                    }
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            'Não foi possível verificar se o monitoramento está ativo'
                    });
                });
        },

        buscarDataUltimaAtualizacao() {
            MonitoramentoService.getDataUltimaAtualizacao(
                this.$route.params.idAreaMonitorada
            )
                .then(({ data }) => {
                    this.dataUltimaAtualizacao = new Date(
                        `${data.year}-${data.monthValue}-${data.dayOfMonth}`
                    );
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            'Não foi possível verificar a data da última atualização'
                    });
                });
        },

        fetchUsuarioLogado() {
            AuthService.isLogged().then(({ data }) => {
                this.usuarioLogado = data;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
#monitoramento {
    .row {
        margin-bottom: 20px;
        gap: 20px;
        justify-content: center;
    }

    header {
        margin-top: -10px;
        margin-bottom: 20px;

        display: flex;
        align-items: center;
        justify-content: flex-start;

        .toggle {
            position: absolute;
            left: 0;
            right: 0;
            margin-left: auto;
            margin-right: auto;
            width: 245.3px;
        }

        .voltar {
            cursor: pointer;
            line-height: 2;
        }
    }

    .aviso {
        display: flex;
        align-items: center;
        width: 450px;
        padding: 2px 4px;
        margin-bottom: 24px;

        background-color: #fffce8;
        border: 1px solid #ffc400;
        border-radius: 4px;

        i {
            font-size: 24px;
            margin: -4px 8px -7px 0px;
        }
    }
}
</style>

<style lang="scss">
.el-switch__label.is-active > span {
    color: var(--primary);
    text-decoration: underline;
}

.isblocoagricola .grupo-alerta-horizontal {
    width: 32% !important;
}

.paddingHeader {
    padding-bottom: 15px;
}

.paddingCondicional {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
}
</style>
